module.exports = __webpack_public_path__ + "img/iphone.1ad8d494.png";